import React, { useState } from 'react';
import './SearchBar.css'



const SearchBar = ({ onSearch, searchResults=[], button=true, selectSearch }) => {

    const handleSearch = (e) => {
        onSearch(e.target.value);
    };

    return (
        <div class="search-container">
            <input onChange={handleSearch} type="text" placeholder="Search..." className={`search-input glassmorphism ${searchResults.length > 0 ? "results" : ""}`}/>
            {button && <button class="search-button glassmorphism">
                <img className='icon' src="/icons/search.png" alt="search Icon"/>
            </button>}
                    {
                    searchResults.length > 0 && (<div className='search-results'>
                        {
                            searchResults.map(service => (
                                <div onClick={()=> selectSearch(service.id)} className='search-result' key={service.id}>
                                    <label>{service.service_name}</label>
                                </div>))
                        }
                    </div>)
                }
        </div>

        
    );
};

export default SearchBar;